<template lang="pug">
  div
    a.btn.btn-primarysmooth.btn-sm(:href="practitionerUrl" v-if="nextAvailability.isValid()")
      .font-sbold {{ $t('components.result_card.next_availablity') }}
      div {{ nextAvailability.calendar() }}
    a.btn.btn-default.btn-sm(:href="practitionerUrl" v-else)
      div Voir les horaires
      .font-sbold de l'ostéopathe
</template>

<script>
  import moment from "moment"

  export default {
    props: {
      practitioner: [Object, String],
      url: String,
      nextAvailablityDate: {
        type: String,
        default: function () {
          return null
        }
      }
    },
    computed: {
      PractitionerIsObject () {
        return typeof this.practitioner === 'object'
      },
      parsedPractitioner () {
        if (!this.PractitionerIsObject) return false
        return this.practitioner
      },
      nextAvailability () {
        const nextAvailablityDate = this.PractitionerIsObject ? this.parsedPractitioner.attributes.next_availability_date : this.nextAvailablityDate
        return moment(nextAvailablityDate).locale(this.$i18n.locale)
      },

      practitionerUrl () {
        return this.PractitionerIsObject ? this.parsedPractitioner.attributes.url : this.url
      }
    }
  }
</script>
